import styled from '@emotion/styled';
import { Box } from '@mafc/trolly';

export const MainContainer = styled(Box)`
  flex: 1 0 auto;
`;
